import React from 'react';
import Routes from './Routes';
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <>
      <Routes />
      <Toaster position="top-right" toastOptions={{ duration: 4000 }} />
    </>
  );
}

export default App;
